import { Union, Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { DocumentTreeVersion_$reflection, DocumentTreeVersion, DocumentCategory, GenericResponse_$reflection, DocumentCategory_$reflection, Document$_$reflection } from "../Shared/ApiDataTypes.js";
import { Tree$2, Tree$2_$reflection } from "../Shared/Tree.js";
import { unit_type, anonRecord_type, obj_type, union_type, record_type, string_type, bool_type, option_type, array_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { FetchError, FetchError_$reflection } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_MapError, FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { maxBy, tryLast, map as map_1, append } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { value as value_192, unwrap, defaultArg, bind, some, map } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { emptyCategory, deleteSubEntry } from "../Documents/DocumentHelpers.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../Context.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { TableContainer, Skeleton, Grid, Divider, MenuItem, Menu, IconButton, Collapse, Typography, ListItem, DialogActions, Button, DialogContent, Checkbox, FormControlLabel, DialogTitle, Dialog } from "@mui/material";
import { comparePrimitives, int32ToString, defaultOf as defaultOf_1, equals, uncurry2, createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { SnackError, wrapTooltip, loadingIndicatorSmall, errorBanner } from "../ViewHelpers.js";
import { cons, empty, singleton, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { empty as empty_1, append as append_1, singleton as singleton_1, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { testRedirect, extraCoders, corsProps } from "../Promises.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { toString } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedEncoder_437914C6, Auto_generateBoxedEncoderCached_437914C6 } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { CategoriesContext, Message as Message_1, CategoriesDispatchContext } from "./DocumentTreeContexts.js";
import Category from "@mui/icons-material/Category";
import Comment$ from "@mui/icons-material/Comment";
import { printf, toText, isNullOrWhiteSpace, join } from "../fable_modules/fable-library-js.4.24.0/String.js";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import CloudOff from "@mui/icons-material/CloudOff";
import MoreHoriz from "@mui/icons-material/MoreHoriz";
import { Changelog_Table_727DA32F, Versions_List_Z2855D50, Versions_Select_Z3AED8366, Branch_DeleteFolderForm_145C481D, BranchForm } from "../Components/TreeAdmin.js";
import { Colors_docTreeLayerToColor } from "../Design.js";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ChevronRight from "@mui/icons-material/ChevronRight";
import { Documents_TreeSyncRule__ToLocalizedString_12C6553D, Documents_TreeSyncRule_TryFromId_Z524259A4, Localization_Language } from "../Shared/Shared.js";
import Close from "@mui/icons-material/Close";
import { defaultOf } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import Sync from "@mui/icons-material/Sync";
import AccountTree from "@mui/icons-material/AccountTree";
import { HookImports_useMediaQuery } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Hooks.fs.js";
import { generateQueryString } from "../Shared/Urls.js";
import { useEffectOnce } from "../fable_modules/Feliz.2.8.0/Internal.fs.js";
import Folder from "@mui/icons-material/Folder";
import Add from "@mui/icons-material/Add";

class Model extends Record {
    constructor(Entries, AddForm, ErrorMsg) {
        super();
        this.Entries = Entries;
        this.AddForm = AddForm;
        this.ErrorMsg = ErrorMsg;
    }
}

function Model_$reflection() {
    return record_type("DocumentTreeAdmin.Model", [], Model, () => [["Entries", option_type(array_type(Tree$2_$reflection(Document$_$reflection(), DocumentCategory_$reflection())))], ["AddForm", bool_type], ["ErrorMsg", option_type(string_type)]]);
}

class Message extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["TreeResponse", "TopLevelEntryAdded", "ToggleAddForm", "EntryDelete", "DismissError"];
    }
}

function Message_$reflection() {
    return union_type("DocumentTreeAdmin.Message", [], Message, () => [[["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Tree$2_$reflection(Document$_$reflection(), DocumentCategory_$reflection())), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(Tree$2_$reflection(Document$_$reflection(), DocumentCategory_$reflection()))]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", DocumentCategory_$reflection()]], [["Item", bool_type]], [["Item", Tree$2_$reflection(Document$_$reflection(), DocumentCategory_$reflection())]], []]);
}

function init() {
    return new Model(undefined, false, undefined);
}

function update(model, msg) {
    switch (msg.tag) {
        case 1: {
            const matchValue = model.Entries;
            if (matchValue != null) {
                return new Model(append(matchValue, [new Tree$2(1, [msg.fields[0], []])]), false, model.ErrorMsg);
            }
            else {
                return model;
            }
        }
        case 2:
            return new Model(model.Entries, msg.fields[0], model.ErrorMsg);
        case 3:
            return new Model(map((entries_1) => deleteSubEntry(msg.fields[0], entries_1), model.Entries), model.AddForm, model.ErrorMsg);
        case 4:
            return new Model(model.Entries, model.AddForm, undefined);
        default: {
            const res = msg.fields[0];
            if (res.tag === 1) {
                switch (res.fields[0].tag) {
                    case 2: {
                        const pr = res.fields[0].fields[0].json();
                        pr.then((msg_1) => {
                            console.error(some("Error fetcing tree"), msg_1);
                        });
                        return model;
                    }
                    case 3: {
                        console.error(some("Network error fetching tree"), res.fields[0].fields[0].message);
                        return model;
                    }
                    case 0: {
                        console.error(some("Preparing request failed fetcing tree"), res.fields[0].fields[0].message);
                        return model;
                    }
                    default: {
                        console.error(some("Error decoding msg"), res.fields[0].fields[0]);
                        return model;
                    }
                }
            }
            else {
                return new Model(res.fields[0], model.AddForm, model.ErrorMsg);
            }
        }
    }
}

function emptyTreeEntry(parentOpt) {
    return new Tree$2(1, [emptyCategory(undefined, bind((_arg) => {
        if (_arg.tag === 1) {
            return _arg.fields[0];
        }
        else {
            return undefined;
        }
    }, parentOpt)), []]);
}

function RevokeTargetForm(revokeTargetFormInputProps) {
    let elements_2, children, elems, children_1;
    const onClose = revokeTargetFormInputProps.onClose;
    const targetId = revokeTargetFormInputProps.targetId;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(false);
    const deleteRelations = patternInput[0];
    const patternInput_1 = reactApi.useState(false);
    const setProcessing = patternInput_1[1];
    const patternInput_2 = reactApi.useState(undefined);
    const setErrMsg = patternInput_2[1];
    return MuiHelpers_createElement(Dialog, [["open", true], ["onClose", (_arg_4, v) => {
        onClose(false);
    }], (elements_2 = [MuiHelpers_createElement(DialogTitle, [["children", ctx.Locale.t("DocumentTree.Admin.RevokeSyncTarget")]]), (children = singleton(createElement("div", createObj(ofArray([["style", {}], (elems = [createElement("p", {
        children: [ctx.Locale.t("DocumentTree.Admin.RevokeSyncDesc")],
    }), MuiHelpers_createElement(FormControlLabel, [["labelPlacement", "end"], ["label", ctx.Locale.t("DocumentTree.Admin.RemoveFromSection")], ["control", MuiHelpers_createElement(Checkbox, [["checked", deleteRelations], ["onChange", (e) => {
        patternInput[1](e.target.checked);
    }], ["color", "primary"], ["id", "checkbox-remove-section"]])]]), createElement("p", {
        children: [ctx.Locale.t("DocumentTree.Admin.RemoveFromSectionDesc")],
    }), errorBanner(patternInput_2[0], () => {
        setErrMsg(undefined);
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), MuiHelpers_createElement(DialogContent, [["children", reactApi.Children.toArray(Array.from(children))]])), (children_1 = toList(delay(() => (patternInput_1[0] ? singleton_1(loadingIndicatorSmall()) : append_1(singleton_1(MuiHelpers_createElement(Button, [["size", "small"], ["variant", "outlined"], ["children", ctx.Locale.t("Cancel")], ["onClick", (_arg_6) => {
        onClose(false);
    }]])), delay(() => singleton_1(MuiHelpers_createElement(Button, [["size", "small"], ["variant", "contained"], ["color", "primary"], ["children", ctx.Locale.t("Delete")], ["onClick", (_arg_7) => {
        const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let decoder, data_1, caseStrategy_2, extra_2;
            return ((decoder = Auto_generateBoxedDecoder_Z6670B51(GenericResponse_$reflection(), undefined, undefined), (data_1 = undefined, (caseStrategy_2 = undefined, (extra_2 = undefined, (() => {
                let properties_2;
                try {
                    const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["DELETE"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
                    const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(`/api/document-tree/admin/sync-rule/${targetId}${`?delete-relations=${deleteRelations}`}`, properties_3).then((_arg) => {
                        let response_1, decoder_1_1;
                        return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(GenericResponse_$reflection(), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                            let matchValue;
                            return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                        })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                    }))));
                    return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
                }
                catch (exn) {
                    return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                }
            })()))))).then((_arg_2) => {
                const res = _arg_2;
                if (res.tag === 0) {
                    const x_1 = res.fields[0];
                    if (x_1.Result === "success") {
                        onClose(true);
                        return Promise.resolve();
                    }
                    else {
                        setProcessing(false);
                        setErrMsg(x_1.Message);
                        return Promise.resolve();
                    }
                }
                else {
                    setErrMsg("Kunne ikke fjerne synkroniseringsregel");
                    setProcessing(false);
                    return Promise.resolve();
                }
            });
        }));
        pr_1.then();
    }]]))))))), MuiHelpers_createElement(DialogActions, [["children", reactApi.Children.toArray(Array.from(children_1))]]))], ["children", reactApi.Children.toArray(Array.from(elements_2))])]);
}

function DrawTree(drawTreeInputProps) {
    let elems, props_1, elems_3, elements, props_5, elements_1, props_14, props_16, props_20, elements_2;
    const entry = drawTreeInputProps.entry;
    const children = drawTreeInputProps.children;
    const parentOpt = drawTreeInputProps.parentOpt;
    const versionOpt = drawTreeInputProps.versionOpt;
    const layer = drawTreeInputProps.layer;
    const key = drawTreeInputProps.$key;
    const ctx = reactApi.useContext(ctx_1);
    const dispatch = reactApi.useContext(CategoriesDispatchContext);
    const anchor = reactApi.useRef(undefined);
    const patternInput = reactApi.useState(entry);
    const updateSelf = patternInput[1];
    const self = patternInput[0];
    let patternInput_1;
    const initial_1 = {
        addForm: false,
        collapsed: false,
        deleteForm: false,
        editForm: false,
        menuOpen: false,
        showDesc: false,
    };
    patternInput_1 = reactApi.useState(initial_1);
    const state = patternInput_1[0];
    const setState = patternInput_1[1];
    const patternInput_2 = reactApi.useState(false);
    const setMenuProcessing = patternInput_2[1];
    const dependencies = [entry];
    reactApi.useEffect(() => {
        updateSelf(entry);
    }, dependencies);
    const categoryName = createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 10 + "px",
    }], (elems = [(props_1 = {
        fontSize: "small",
    }, react.createElement(Category, props_1)), createElement("span", {
        children: (ctx.Language.tag === 1) ? self.NameEN : self.NameNO,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
    const descriptionIcon = createElement("div", createObj(ofArray([["style", {
        width: 100 + "%",
    }], (elems_3 = [MuiHelpers_createElement(ListItem, [["onClick", (_arg_6) => {
        setState({
            addForm: state.addForm,
            collapsed: state.collapsed,
            deleteForm: state.deleteForm,
            editForm: state.editForm,
            menuOpen: state.menuOpen,
            revokeTargetForm: unwrap(state.revokeTargetForm),
            showDesc: !state.showDesc,
        });
    }], ["style", {
        display: "flex",
        alignItems: "center",
        gap: 10 + "px",
    }], ["button", true], ["dense", true], ["selected", state.showDesc], ["disableGutters", false], (elements = [(props_5 = {
        fontSize: "small",
        style: {},
    }, react.createElement(Comment$, props_5)), MuiHelpers_createElement(Typography, [["variant", "body2"], ["children", (ctx.Language.tag === 1) ? "Has description" : "Har beskrivelse"]])], ["children", reactApi.Children.toArray(Array.from(elements))])]), MuiHelpers_createElement(Collapse, [["in", state.showDesc], (elements_1 = [createElement("pre", {
        wrap: "soft",
        children: (ctx.Language.tag === 1) ? self.DescEN : self.DescNO,
    })], ["children", reactApi.Children.toArray(Array.from(elements_1))])])], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
    const iconContainer = (desc, children_3) => {
        let elems_4;
        return createElement("div", createObj(ofArray([["title", desc], ["style", {
            display: "flex",
            alignItems: "center",
            gap: 10 + "px",
            maxWidth: 80 + "ch",
            overflowX: "hidden",
            paddingTop: 4 + "px",
            paddingLeft: 16 + "px",
            paddingRight: 16 + "px",
            paddingBottom: 4 + "px",
        }], (elems_4 = [children_3, MuiHelpers_createElement(Typography, [["className", join(" ", ["text-overflow"])], ["variant", "body2"], ["children", desc]])], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
    };
    const visibilityIcon = iconContainer("Synlig kun for PTG", [wrapTooltip(ctx.Locale.t("DocumentTree.Admin.VisibilityPtgOnly"), (props_14 = {
        fontSize: "small",
        style: {},
    }, react.createElement(VisibilityOff, props_14)))]);
    const directUploadIcon = iconContainer("Kan ikke lastes opp direkte", [(props_16 = {
        fontSize: "small",
    }, react.createElement(CloudOff, props_16))]);
    const openMenuButton = MuiHelpers_createElement(IconButton, [["ref", anchor], ["style", {
        color: "#000000",
    }], ["onClick", (_arg_7) => {
        setState({
            addForm: state.addForm,
            collapsed: state.collapsed,
            deleteForm: state.deleteForm,
            editForm: state.editForm,
            menuOpen: !state.menuOpen,
            revokeTargetForm: unwrap(state.revokeTargetForm),
            showDesc: state.showDesc,
        });
    }], ["size", "small"], ["children", patternInput_2[0] ? loadingIndicatorSmall() : ((props_20 = {}, react.createElement(MoreHoriz, props_20)))]]);
    const editMenu = MuiHelpers_createElement(Menu, [["open", state.menuOpen], ["onClose", (_arg_9, v) => {
        setState({
            addForm: state.addForm,
            collapsed: state.collapsed,
            deleteForm: state.deleteForm,
            editForm: state.editForm,
            menuOpen: false,
            revokeTargetForm: unwrap(state.revokeTargetForm),
            showDesc: state.showDesc,
        });
        setMenuProcessing(false);
    }], ["anchorEl", () => anchor.current], (elements_2 = [MuiHelpers_createElement(MenuItem, [["children", ctx.Locale.t("DocumentTree.Admin.AddChild")], ["onClick", (_arg_10) => {
        setState({
            addForm: true,
            collapsed: state.collapsed,
            deleteForm: state.deleteForm,
            editForm: state.editForm,
            menuOpen: false,
            revokeTargetForm: unwrap(state.revokeTargetForm),
            showDesc: state.showDesc,
        });
    }]]), MuiHelpers_createElement(MenuItem, [["children", ctx.Locale.t("Edit")], ["onClick", (_arg_11) => {
        setState({
            addForm: state.addForm,
            collapsed: state.collapsed,
            deleteForm: state.deleteForm,
            editForm: true,
            menuOpen: false,
            revokeTargetForm: unwrap(state.revokeTargetForm),
            showDesc: state.showDesc,
        });
    }]]), MuiHelpers_createElement(MenuItem, [["children", self.PtgOnly ? ctx.Locale.t("DocumentTree.Admin.SetVisible") : ctx.Locale.t("DocumentTree.Admin.RevokeVisible")], ["onClick", (_arg_12) => {
        let properties_9;
        setMenuProcessing(true);
        const isVisible = self.PtgOnly;
        let pr_5;
        const item_1 = {
            Visible: !isVisible,
        };
        const data_8 = some(Auto_generateBoxedEncoder_437914C6(anonRecord_type(["Visible", bool_type]), undefined, undefined, undefined)(item_1));
        const decoder_6 = Auto_generateBoxedDecoder_Z6670B51(GenericResponse_$reflection(), undefined, undefined);
        const data_9 = data_8;
        const caseStrategy_20 = undefined;
        const extra_20 = undefined;
        try {
            const properties_3_2 = Helper_withProperties(corsProps, (properties_9 = ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_9, empty()), 0)])]), defaultArg(map((data_1_3) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_20), unwrap(extra_20))(data_1_3))]), properties_9), data_9), properties_9)));
            const pr_4 = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(`/api/document-tree/admin/visible/${self.Id}`, properties_3_2).then((_arg_4) => {
                let response_5, decoder_1_3;
                return ((response_5 = _arg_4, (decoder_1_3 = defaultArg(decoder_6, Auto_generateBoxedDecoderCached_Z6670B51(GenericResponse_$reflection(), unwrap(caseStrategy_20), unwrap(extra_20))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_5.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_5.text().then((_arg_5) => {
                    let matchValue_2;
                    return Promise.resolve((matchValue_2 = fromString(uncurry2(decoder_1_3), _arg_5), (matchValue_2.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_2.fields[0]])])) : (new FSharpResult$2(0, [matchValue_2.fields[0]]))));
                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_5])])))).then((_arg_1_3) => (Promise.resolve(_arg_1_3)))))))));
            }))));
            pr_5 = (pr_4.then(void 0, ((arg_2) => (new FSharpResult$2(1, [new FetchError(3, [arg_2])])))));
        }
        catch (exn_2) {
            pr_5 = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn_2])])))));
        }
        pr_5.then((res_2) => {
            if (res_2.tag === 0) {
                if (res_2.fields[0].Result === "success") {
                    const newVisible = !isVisible;
                    updateSelf(new DocumentCategory(self.Id, self.ParentId, self.Version, self.MachineId, self.Enabled, newVisible, self.AllowUpload, self.AllowMachineSubCategories, self.NameNO, self.NameEN, self.DescNO, self.DescEN, self.SyncRules));
                    dispatch(new Message_1(3, [self.Id, (child) => (new DocumentCategory(child.Id, child.ParentId, child.Version, child.MachineId, child.Enabled, newVisible, child.AllowUpload, child.AllowMachineSubCategories, child.NameNO, child.NameEN, child.DescNO, child.DescEN, child.SyncRules))]));
                }
            }
            else {
                console.error(some("Failed updating node\'s visibility:"), res_2.fields[0]);
            }
            setMenuProcessing(false);
        });
        setState({
            addForm: state.addForm,
            collapsed: state.collapsed,
            deleteForm: state.deleteForm,
            editForm: state.editForm,
            menuOpen: false,
            revokeTargetForm: unwrap(state.revokeTargetForm),
            showDesc: state.showDesc,
        });
    }]]), MuiHelpers_createElement(MenuItem, [["children", self.Enabled ? ctx.Locale.t("DocumentTree.Admin.Disable") : ctx.Locale.t("DocumentTree.Admin.Enable")], ["onClick", (_arg_13) => {
        let properties_2;
        setMenuProcessing(true);
        const isEnabled = !self.Enabled;
        let pr_1;
        const data = some(Auto_generateBoxedEncoder_437914C6(string_type, undefined, undefined, undefined)(""));
        const decoder = Auto_generateBoxedDecoder_Z6670B51(GenericResponse_$reflection(), undefined, undefined);
        const data_1 = data;
        const caseStrategy_3 = undefined;
        const extra_3 = undefined;
        try {
            const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
            const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(`/api/document-tree/admin/enable/${self.Id}?enabled=${isEnabled}`, properties_3).then((_arg) => {
                let response_1, decoder_1_1;
                return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(GenericResponse_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                    let matchValue;
                    return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
            }))));
            pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
        }
        catch (exn) {
            pr_1 = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
        }
        pr_1.then((res) => {
            if (res.tag === 0) {
                if (res.fields[0].Result === "success") {
                    updateSelf(new DocumentCategory(self.Id, self.ParentId, self.Version, self.MachineId, isEnabled, self.PtgOnly, self.AllowUpload, self.AllowMachineSubCategories, self.NameNO, self.NameEN, self.DescNO, self.DescEN, self.SyncRules));
                }
            }
            else {
                console.error(some("Could not set enabled:"), res.fields[0]);
            }
            setMenuProcessing(false);
        });
        setState({
            addForm: state.addForm,
            collapsed: state.collapsed,
            deleteForm: state.deleteForm,
            editForm: state.editForm,
            menuOpen: false,
            revokeTargetForm: unwrap(state.revokeTargetForm),
            showDesc: state.showDesc,
        });
    }]]), MuiHelpers_createElement(MenuItem, [["children", ctx.Locale.t("Delete")], ["onClick", (_arg_14) => {
        setState({
            addForm: state.addForm,
            collapsed: state.collapsed,
            deleteForm: true,
            editForm: state.editForm,
            menuOpen: false,
            revokeTargetForm: unwrap(state.revokeTargetForm),
            showDesc: state.showDesc,
        });
    }]])], ["children", reactApi.Children.toArray(Array.from(elements_2))])]);
    const xs_15 = toList(delay(() => {
        let $keyZ744B596E;
        return append_1(singleton_1(($keyZ744B596E = (`tree-${entry.Id}-add-branch-form`), createElement(BranchForm, {
            key: $keyZ744B596E,
            $key: $keyZ744B596E,
            isOpen: state.addForm,
            version: unwrap(versionOpt),
            parent: self,
            onClose: (newEntryOpt) => {
                if (newEntryOpt != null) {
                    dispatch(new Message_1(0, [self.Id, newEntryOpt]));
                    setState({
                        addForm: false,
                        collapsed: false,
                        deleteForm: state.deleteForm,
                        editForm: state.editForm,
                        menuOpen: state.menuOpen,
                        revokeTargetForm: unwrap(state.revokeTargetForm),
                        showDesc: state.showDesc,
                    });
                }
                else {
                    setState({
                        addForm: false,
                        collapsed: state.collapsed,
                        deleteForm: state.deleteForm,
                        editForm: state.editForm,
                        menuOpen: state.menuOpen,
                        revokeTargetForm: unwrap(state.revokeTargetForm),
                        showDesc: state.showDesc,
                    });
                }
            },
        }))), delay(() => {
            let $keyZ48F699AE;
            return append_1(singleton_1(($keyZ48F699AE = (`tree-${entry.Id}-edit-branch-form`), createElement(BranchForm, {
                key: $keyZ48F699AE,
                $key: $keyZ48F699AE,
                isOpen: state.editForm,
                version: unwrap(versionOpt),
                updating: self,
                parent: unwrap(parentOpt),
                onClose: (updatedOpt) => {
                    const testUpdate = (x_6, y, def) => {
                        if (!equals(x_6, y)) {
                            return y;
                        }
                        else {
                            return def;
                        }
                    };
                    if (updatedOpt != null) {
                        const updated = value_192(updatedOpt);
                        if (!(children.length === 0) && (((self.Enabled !== updated.Enabled) ? true : (self.AllowUpload !== updated.AllowUpload)) ? true : (self.PtgOnly !== updated.PtgOnly))) {
                            console.debug("Update all children!");
                            dispatch(new Message_1(3, [self.Id, (child_1) => {
                                if (child_1.Id === self.Id) {
                                    return child_1;
                                }
                                else {
                                    const Enabled = testUpdate(self.Enabled, updated.Enabled, child_1.Enabled);
                                    const AllowUpload = testUpdate(self.AllowUpload, updated.AllowUpload, child_1.AllowUpload);
                                    return new DocumentCategory(child_1.Id, child_1.ParentId, child_1.Version, child_1.MachineId, Enabled, testUpdate(self.PtgOnly, updated.PtgOnly, child_1.PtgOnly), AllowUpload, child_1.AllowMachineSubCategories, child_1.NameNO, child_1.NameEN, child_1.DescNO, child_1.DescEN, child_1.SyncRules);
                                }
                            }]));
                        }
                        updateSelf(updated);
                    }
                    setState({
                        addForm: state.addForm,
                        collapsed: state.collapsed,
                        deleteForm: state.deleteForm,
                        editForm: false,
                        menuOpen: state.menuOpen,
                        revokeTargetForm: unwrap(state.revokeTargetForm),
                        showDesc: state.showDesc,
                    });
                },
            }))), delay(() => append_1(singleton_1(createElement(Branch_DeleteFolderForm_145C481D, {
                isOpen: state.deleteForm,
                folder: entry,
                onClose: (deleted) => {
                    setState({
                        addForm: state.addForm,
                        collapsed: state.collapsed,
                        deleteForm: false,
                        editForm: state.editForm,
                        menuOpen: state.menuOpen,
                        revokeTargetForm: unwrap(state.revokeTargetForm),
                        showDesc: state.showDesc,
                    });
                    if (deleted) {
                        dispatch(new Message_1(1, [entry]));
                    }
                },
            })), delay(() => {
                let matchValue_6, rtf;
                return append_1((matchValue_6 = state.revokeTargetForm, (matchValue_6 != null) ? ((rtf = (matchValue_6 | 0), singleton_1(createElement(RevokeTargetForm, {
                    targetId: rtf,
                    onClose: (didRemove) => {
                        if (didRemove) {
                            updateSelf(new DocumentCategory(self.Id, self.ParentId, self.Version, self.MachineId, self.Enabled, self.PtgOnly, self.AllowUpload, self.AllowMachineSubCategories, self.NameNO, self.NameEN, self.DescNO, self.DescEN, self.SyncRules.filter((r) => (r.TargetId !== rtf))));
                        }
                        setState({
                            addForm: state.addForm,
                            collapsed: state.collapsed,
                            deleteForm: state.deleteForm,
                            editForm: state.editForm,
                            menuOpen: state.menuOpen,
                            showDesc: state.showDesc,
                        });
                    },
                })))) : (empty_1())), delay(() => {
                    let elems_15, elems_10, elems_9, elems_7, elems_6, elems_14, elements_3, elems_12;
                    return singleton_1(createElement("div", createObj(ofArray([["style", {
                        backgroundColor: Colors_docTreeLayerToColor(layer),
                        padding: 5 + "px",
                        marginTop: 10 + "px",
                        marginBottom: 10 + "px",
                    }], (elems_15 = [createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        paddingLeft: 12,
                        alignItems: "center",
                    }], (elems_10 = [createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append_1(!self.Enabled ? singleton_1(["opacity", 0.5]) : empty_1(), delay(() => append_1(singleton_1(["padding", 5]), delay(() => append_1(singleton_1(["width", 100 + "%"]), delay(() => append_1(singleton_1(["display", "flex"]), delay(() => singleton_1(["alignItems", "center"]))))))))))))], (elems_9 = [createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        alignItems: "center",
                        flexGrow: 1,
                    }], (elems_7 = [createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                    }], ["onClick", (_arg_15) => {
                        setState({
                            addForm: state.addForm,
                            collapsed: !state.collapsed,
                            deleteForm: state.deleteForm,
                            editForm: state.editForm,
                            menuOpen: state.menuOpen,
                            revokeTargetForm: unwrap(state.revokeTargetForm),
                            showDesc: state.showDesc,
                        });
                    }], (elems_6 = toList(delay(() => {
                        let props_29, props_31;
                        return append_1(!state.collapsed ? singleton_1((props_29 = {}, react.createElement(ExpandMore, props_29))) : singleton_1((props_31 = {}, react.createElement(ChevronRight, props_31))), delay(() => append_1(singleton_1(createElement("span", {
                            children: equals(ctx.Language, new Localization_Language(0, [])) ? self.NameNO : self.NameEN,
                        })), delay(() => {
                            let props_34;
                            return !self.Enabled ? singleton_1((props_34 = {
                                style: {
                                    color: "#FF0000",
                                },
                            }, react.createElement(Close, props_34))) : empty_1();
                        }))));
                    })), ["children", reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", reactApi.Children.toArray(Array.from(elems_7))])]))), createElement("div", {
                        style: {
                            display: "flex",
                            alignItems: "center",
                            gap: 10 + "px",
                        },
                        children: reactApi.Children.toArray([openMenuButton, editMenu]),
                    })], ["children", reactApi.Children.toArray(Array.from(elems_9))])])))], ["children", reactApi.Children.toArray(Array.from(elems_10))])]))), createElement("div", createObj(ofArray([["style", {
                        marginLeft: 24,
                        paddingLeft: 20 + "px",
                        paddingRight: 40 + "px",
                    }], (elems_14 = [MuiHelpers_createElement(Collapse, [["in", !state.collapsed], (elements_3 = [createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "start",
                        paddingBottom: 10 + "px",
                        fontSize: 13 + "px",
                        color: "#666",
                    }], (elems_12 = toList(delay(() => {
                        let elems_11;
                        return append_1(singleton_1(createElement("div", createObj(ofArray([["style", {
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "start",
                            flexWrap: "wrap",
                            columnGap: 25 + "px",
                            width: 100 + "%",
                        }], (elems_11 = toList(delay(() => append_1(self.PtgOnly ? singleton_1(visibilityIcon) : empty_1(), delay(() => append_1(!self.AllowUpload ? singleton_1(directUploadIcon) : empty_1(), delay(() => singleton_1(map_1((syncRule) => {
                            let props_18;
                            const categoryOpt = Documents_TreeSyncRule_TryFromId_Z524259A4(syncRule.TargetId);
                            if (categoryOpt == null) {
                                return defaultOf();
                            }
                            else {
                                const categoryStr = Documents_TreeSyncRule__ToLocalizedString_12C6553D(value_192(categoryOpt), ctx.Language);
                                return iconContainer(ctx.Locale.t("DocumentTree.Admin.CategorySyncsHere", ((x,a)=>{let o=(x||{});o[a[0]]=a[1];return o})(defaultOf_1(),["category", categoryStr])), [(props_18 = {}, react.createElement(Sync, props_18))]);
                            }
                        }, self.SyncRules)))))))), ["children", reactApi.Children.toArray(Array.from(elems_11))])])))), delay(() => ((!isNullOrWhiteSpace(self.DescNO) && !isNullOrWhiteSpace(self.DescEN)) ? singleton_1(descriptionIcon) : empty_1())));
                    })), ["children", reactApi.Children.toArray(Array.from(elems_12))])]))), map_1((_arg_16) => {
                        if (_arg_16.tag === 1) {
                            const child_2 = _arg_16.fields[0];
                            const $keyZ2F203A0E = `tree-subtree-${child_2.Id}`;
                            return createElement(DrawTree, {
                                key: $keyZ2F203A0E,
                                $key: $keyZ2F203A0E,
                                layer: layer + 1,
                                versionOpt: unwrap(versionOpt),
                                parentOpt: self,
                                children: _arg_16.fields[1],
                                entry: child_2,
                            });
                        }
                        else {
                            return defaultOf();
                        }
                    }, children)], ["children", reactApi.Children.toArray(Array.from(elements_3))])])], ["children", reactApi.Children.toArray(Array.from(elems_14))])])))], ["children", reactApi.Children.toArray(Array.from(elems_15))])]))));
                }));
            }))));
        }));
    }));
    return react.createElement(react.Fragment, {}, ...xs_15);
}

export function ActivationButton(activationButtonInputProps) {
    let elements_2, children, children_1, props_6;
    const currentVersion = activationButtonInputProps.currentVersion;
    const onClose = activationButtonInputProps.onClose;
    const disabled = activationButtonInputProps.disabled;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(false);
    const setActivateModal = patternInput[1];
    const patternInput_1 = reactApi.useState(false);
    const setActivating = patternInput_1[1];
    const activating = patternInput_1[0];
    const patternInput_2 = reactApi.useState(undefined);
    const setErrMsg = patternInput_2[1];
    const handleClose = (opt) => {
        setErrMsg(undefined);
        setActivating(false);
        setActivateModal(false);
        onClose(opt);
    };
    const xs = [MuiHelpers_createElement(Dialog, [["open", patternInput[0]], ["onClose", (_arg_3, v) => {
        handleClose(undefined);
    }], (elements_2 = [MuiHelpers_createElement(DialogTitle, [["children", "Er du sikker på at du vil aktivere denne versjonen?"]]), (children = ofArray([MuiHelpers_createElement(Typography, [["children", "Alle nye maskiner vil bli tildelt denne dokumentstrukturen om du aktiverer denne versjonen. Du vil ikke kunne gjøre videre endringer på denne strukturen isåfall, og måtte da lage en ny versjon for videre endringer."]]), errorBanner(patternInput_2[0], () => {
        setErrMsg(undefined);
    })]), MuiHelpers_createElement(DialogContent, [["children", reactApi.Children.toArray(Array.from(children))]])), (children_1 = ofArray([MuiHelpers_createElement(Button, [["size", "small"], ["variant", "contained"], ["children", ctx.Locale.t("Cancel")], ["onClick", (_arg_4) => {
        handleClose(undefined);
    }]]), MuiHelpers_createElement(Button, [["onClick", (_arg_5) => {
        let properties_2;
        setErrMsg(undefined);
        const version = value_192(currentVersion);
        setActivating(true);
        const url = toText(printf("/api/document-tree/admin/versions/%i"))(version.Id);
        let pr_1;
        const item = new DocumentTreeVersion(version.Id, true);
        const data = some(Auto_generateBoxedEncoder_437914C6(DocumentTreeVersion_$reflection(), undefined, undefined, undefined)(item));
        const decoder = Auto_generateBoxedDecoder_Z6670B51(DocumentTreeVersion_$reflection(), undefined, undefined);
        const data_1 = data;
        const caseStrategy_3 = undefined;
        const extra_3 = undefined;
        try {
            const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
            const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(url, properties_3).then((_arg) => {
                let response_1, decoder_1_1;
                return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(DocumentTreeVersion_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                    let matchValue;
                    return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
            }))));
            pr_1 = (pr.then(void 0, ((arg_1) => (new FSharpResult$2(1, [new FetchError(3, [arg_1])])))));
        }
        catch (exn) {
            pr_1 = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
        }
        pr_1.then((res) => {
            if (res.tag === 0) {
                handleClose(res.fields[0]);
            }
            else {
                console.error(some("Failed activating version:"), res.fields[0]);
                setErrMsg("Kunne ikke aktivere versjon. Vennligst prøv igjen senere.");
            }
            setActivating(false);
        });
    }], ["size", "small"], ["variant", "contained"], ["color", "secondary"], ["disabled", activating], ["startIcon", activating ? loadingIndicatorSmall() : defaultOf()], ["children", ctx.Locale.t("Activate")]])]), MuiHelpers_createElement(DialogActions, [["children", reactApi.Children.toArray(Array.from(children_1))]]))], ["children", reactApi.Children.toArray(Array.from(elements_2))])]), MuiHelpers_createElement(Button, [["onClick", (_arg_6) => {
        setActivateModal(true);
    }], ["variant", "contained"], ["disabled", (currentVersion == null) ? true : disabled], ["startIcon", activating ? loadingIndicatorSmall() : ((props_6 = {}, react.createElement(AccountTree, props_6)))], ["children", "Aktiver"]])];
    return react.createElement(react.Fragment, {}, ...xs);
}

/**
 * Top level component for administrating the overall document tree strucutre
 */
export function DocumentTreeAdmin(documentTreeAdminInputProps) {
    const key = documentTreeAdminInputProps.$key;
    const categoryDispatch = reactApi.useContext(CategoriesDispatchContext);
    const categories = reactApi.useContext(CategoriesContext);
    let patternInput;
    const arg_1 = init();
    patternInput = reactApi.useReducer(update, arg_1);
    const model_1 = patternInput[0];
    const dispatch = patternInput[1];
    const patternInput_1 = reactApi.useState(false);
    const setLoading = patternInput_1[1];
    const loading = patternInput_1[0];
    const patternInput_2 = reactApi.useState([]);
    const versions = patternInput_2[0];
    const setVersions = patternInput_2[1];
    const patternInput_3 = reactApi.useState(true);
    const versionLoading = patternInput_3[0];
    const setVersionLoading = patternInput_3[1];
    const patternInput_4 = reactApi.useState(undefined);
    const setCurrentVersion = patternInput_4[1];
    const currentVersion = patternInput_4[0];
    const patternInput_5 = reactApi.useState(false);
    const setCreating = patternInput_5[1];
    const creating = patternInput_5[0];
    const xs = HookImports_useMediaQuery("(min-width: 0px)");
    const sm = HookImports_useMediaQuery("(min-width: 600px)");
    const md = HookImports_useMediaQuery("(min-width: 959px)");
    const lg = HookImports_useMediaQuery("(min-width: 1279px)");
    const currentVersionIdOpt = map((version) => version.Id, currentVersion);
    const handleVersionChanged = (newVersion) => {
        setCurrentVersion(newVersion);
    };
    const stillEditing = defaultArg(map((v) => !v.Active, tryLast(versions)), false);
    const activationButtonDisabled = ((loading ? true : (currentVersion == null)) ? true : defaultArg(map((version_1) => version_1.Active, currentVersion), false)) ? true : !stillEditing;
    const handleCreateVersion = () => {
        let properties_2;
        setCreating(true);
        let pr_1;
        const body = void Auto_generateBoxedEncoder_437914C6(unit_type, undefined, undefined, undefined)();
        const decoder = Auto_generateBoxedDecoder_Z6670B51(DocumentTreeVersion_$reflection(), undefined, undefined);
        const data_1 = some(body);
        const caseStrategy_3 = undefined;
        const extra_3 = undefined;
        try {
            const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
            const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch("/api/document-tree/admin/versions", properties_3).then((_arg) => {
                let response_1, decoder_1_1;
                return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(DocumentTreeVersion_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                    let matchValue;
                    return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
            }))));
            pr_1 = (pr.then(void 0, ((arg_2) => (new FSharpResult$2(1, [new FetchError(3, [arg_2])])))));
        }
        catch (exn) {
            pr_1 = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
        }
        pr_1.then((res) => {
            if (res.tag === 0) {
                const newVersion_1 = res.fields[0];
                setVersions(append(versions, [newVersion_1]));
                handleVersionChanged(newVersion_1);
            }
            else {
                throw new Error("todo");
            }
            setCreating(false);
        });
    };
    const onVersionActivated = (newOpt) => {
        if (newOpt != null) {
            const activatedVersion = value_192(newOpt);
            setVersions(map_1((existing) => {
                if (existing.Id === activatedVersion.Id) {
                    return activatedVersion;
                }
                else {
                    return existing;
                }
            }, versions));
        }
    };
    const dependencies = [currentVersion, versionLoading];
    reactApi.useEffect(() => {
        let properties_6;
        const url_4 = "/api/document-tree/admin" + generateQueryString([["version", defaultArg(map((version_2) => int32ToString(version_2.Id), currentVersion), "")]]);
        if (!versionLoading) {
            console.debug("loading tree from version", currentVersion);
            setLoading(true);
            let pr_4;
            let pr_3;
            const decoder_3 = Auto_generateBoxedDecoder_Z6670B51(array_type(Tree$2_$reflection(Document$_$reflection(), DocumentCategory_$reflection())), undefined, undefined);
            const data_5 = undefined;
            const caseStrategy_11 = undefined;
            const extra_11 = extraCoders;
            try {
                const properties_3_1 = Helper_withProperties(undefined, (properties_6 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_5, empty()), 0)])]), defaultArg(map((data_1_2) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_11), unwrap(extra_11))(data_1_2))]), properties_6), data_5), properties_6)));
                const pr_2 = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(url_4, properties_3_1).then((_arg_3) => {
                    let response_3, decoder_1_2;
                    return ((response_3 = _arg_3, (decoder_1_2 = defaultArg(decoder_3, Auto_generateBoxedDecoderCached_Z6670B51(array_type(Tree$2_$reflection(Document$_$reflection(), DocumentCategory_$reflection())), unwrap(caseStrategy_11), unwrap(extra_11))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_3.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_3.text().then((_arg_4) => {
                        let matchValue_1;
                        return Promise.resolve((matchValue_1 = fromString(uncurry2(decoder_1_2), _arg_4), (matchValue_1.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_1.fields[0]])])) : (new FSharpResult$2(0, [matchValue_1.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_3])])))).then((_arg_1_2) => (Promise.resolve(_arg_1_2)))))))));
                }))));
                pr_3 = (pr_2.then(void 0, ((arg_3) => (new FSharpResult$2(1, [new FetchError(3, [arg_3])])))));
            }
            catch (exn_1) {
                pr_3 = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn_1])])))));
            }
            pr_4 = (pr_3.then((result_2) => Result_MapError(testRedirect, result_2)));
            pr_4.then((res_1) => {
                if (res_1.tag === 0) {
                    categoryDispatch(new Message_1(2, [res_1.fields[0]]));
                }
                else {
                    console.error(some("could not load categories"), res_1.fields[0]);
                }
                setLoading(false);
            });
        }
    }, dependencies);
    useEffectOnce(() => {
        let properties_9;
        setVersionLoading(true);
        let pr_7;
        let pr_6;
        const decoder_6 = Auto_generateBoxedDecoder_Z6670B51(array_type(DocumentTreeVersion_$reflection()), undefined, undefined);
        const data_9 = undefined;
        const caseStrategy_19 = undefined;
        const extra_19 = extraCoders;
        try {
            const properties_3_2 = Helper_withProperties(undefined, (properties_9 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_9, empty()), 0)])]), defaultArg(map((data_1_3) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_19), unwrap(extra_19))(data_1_3))]), properties_9), data_9), properties_9)));
            const pr_5 = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch("/api/document-tree/admin/versions", properties_3_2).then((_arg_5) => {
                let response_5, decoder_1_3;
                return ((response_5 = _arg_5, (decoder_1_3 = defaultArg(decoder_6, Auto_generateBoxedDecoderCached_Z6670B51(array_type(DocumentTreeVersion_$reflection()), unwrap(caseStrategy_19), unwrap(extra_19))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_5.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_5.text().then((_arg_6) => {
                    let matchValue_2;
                    return Promise.resolve((matchValue_2 = fromString(uncurry2(decoder_1_3), _arg_6), (matchValue_2.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_2.fields[0]])])) : (new FSharpResult$2(0, [matchValue_2.fields[0]]))));
                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_5])])))).then((_arg_1_3) => (Promise.resolve(_arg_1_3)))))))));
            }))));
            pr_6 = (pr_5.then(void 0, ((arg_4) => (new FSharpResult$2(1, [new FetchError(3, [arg_4])])))));
        }
        catch (exn_2) {
            pr_6 = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn_2])])))));
        }
        pr_7 = (pr_6.then((result_4) => Result_MapError(testRedirect, result_4)));
        pr_7.then((res_2) => {
            if (res_2.tag === 0) {
                const versions_1 = res_2.fields[0];
                if (versions_1.length === 0) {
                    setCurrentVersion(undefined);
                }
                else {
                    setCurrentVersion(maxBy((version_3) => version_3.Id, versions_1, {
                        Compare: comparePrimitives,
                    }));
                }
                setVersions(versions_1);
            }
            else {
                console.error(some("Failed fetching versions"), res_2.fields[0]);
            }
            setVersionLoading(false);
        });
    });
    const xs_5 = toList(delay(() => append_1(singleton_1(createElement(SnackError, {
        errMsg: unwrap(model_1.ErrorMsg),
        dismiss: () => {
            dispatch(new Message(4, []));
        },
    })), delay(() => append_1(model_1.AddForm ? singleton_1(createElement(BranchForm, {
        key: "top-level-add-branch-form",
        $key: "top-level-add-branch-form",
        isOpen: true,
        version: unwrap(currentVersionIdOpt),
        onClose: (newBranchOpt) => {
            if (newBranchOpt != null) {
                categoryDispatch(new Message_1(0, [undefined, value_192(newBranchOpt)]));
            }
            dispatch(new Message(2, [false]));
        },
    })) : empty_1(), delay(() => {
        let elems_10, elems, elements_6;
        return singleton_1(createElement("div", createObj(ofArray([["style", {}], (elems_10 = [createElement("div", createObj(singleton((elems = [MuiHelpers_createElement(Typography, [["variant", "h1"], ["children", "Dokumentstruktur"]]), MuiHelpers_createElement(Typography, [["style", {
            maxWidth: 120 + "ch",
        }], ["variant", "body2"], ["paragraph", true], ["children", "Dokumentstrukturen representerer mappestrukturen for dokumenter under kunder. Her kan du legge til, endre eller deaktivere mapper, endre synlighet på dem, og administrere synkronisering av nye dokumenter."]])], ["children", reactApi.Children.toArray(Array.from(elems))])))), MuiHelpers_createElement(Divider, [["style", {
            marginBottom: 32 + "px",
        }], ["variant", "fullWidth"]]), MuiHelpers_createElement(Grid, [["className", join(" ", ["large-max-width"])], ["style", {
            rowGap: 30 + "px",
        }], ["container", true], (elements_6 = toList(delay(() => {
            let elements;
            return append_1(!sm ? singleton_1(MuiHelpers_createElement(Grid, [["style", {
                display: "flex",
                flexDirection: "column",
                rowGap: 20 + "px",
            }], ["xs", 12], ["item", true], ["container", true], (elements = toList(delay(() => {
                let elems_1, props_5, props_8;
                return append_1(singleton_1(createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    justifyContent: "space-evenly",
                    alignItems: "center",
                }], (elems_1 = [MuiHelpers_createElement(Button, [["onClick", (_arg_8) => {
                    dispatch(new Message(2, [!model_1.AddForm]));
                }], ["variant", "contained"], ["disabled", defaultArg(map((version_4) => version_4.Active, currentVersion), true)], ["children", (props_5 = {}, react.createElement(Folder, props_5))]]), MuiHelpers_createElement(Button, [["onClick", (_arg_9) => {
                    handleCreateVersion();
                }], ["variant", "contained"], ["disabled", (loading ? true : stillEditing) ? true : creating], ["children", creating ? loadingIndicatorSmall() : ((props_8 = {}, react.createElement(Add, props_8)))]]), createElement(ActivationButton, {
                    disabled: activationButtonDisabled,
                    onClose: onVersionActivated,
                    currentVersion: unwrap(currentVersion),
                })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                    let elems_2;
                    return versionLoading ? singleton_1(loadingIndicatorSmall()) : singleton_1(createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 10 + "px",
                        width: 100 + "%",
                    }], (elems_2 = [createElement(Versions_Select_Z3AED8366, {
                        currentVersion: unwrap(currentVersion),
                        versions: versions,
                        onSelect: handleVersionChanged,
                    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
                }));
            })), ["children", reactApi.Children.toArray(Array.from(elements))])])) : empty_1(), delay(() => {
                let elements_3;
                return append_1(singleton_1(MuiHelpers_createElement(Grid, [["style", {
                    columnGap: 40 + "px",
                    justifyContent: "flex-start",
                    alignItems: "start",
                }], ["xs", 12], ["item", true], ["container", true], ["zeroMinWidth", true], (elements_3 = toList(delay(() => {
                    let elements_1;
                    return append_1(singleton_1(MuiHelpers_createElement(Grid, [["style", {}], ["item", true], ["xs", 12], ["sm", 8], (elements_1 = toList(delay(() => {
                        if (loading) {
                            const loading_1 = () => MuiHelpers_createElement(Skeleton, [["variant", "rectangular"], ["style", {
                                width: 100 + "%",
                                height: 50,
                                marginBottom: 10,
                            }]]);
                            return append_1(singleton_1(loading_1()), delay(() => append_1(singleton_1(loading_1()), delay(() => singleton_1(loading_1())))));
                        }
                        else {
                            return singleton_1(map_1((_arg_10) => {
                                if (_arg_10.tag === 1) {
                                    const category = _arg_10.fields[0];
                                    const $keyZ57C5F6E6 = `tree-${category.Id}`;
                                    return createElement(DrawTree, {
                                        key: $keyZ57C5F6E6,
                                        $key: $keyZ57C5F6E6,
                                        layer: 0,
                                        versionOpt: unwrap(currentVersionIdOpt),
                                        children: _arg_10.fields[1],
                                        entry: category,
                                    });
                                }
                                else {
                                    return defaultOf();
                                }
                            }, categories));
                        }
                    })), ["children", reactApi.Children.toArray(Array.from(elements_1))])])), delay(() => {
                        let elements_2, props_16, props_19;
                        return sm ? singleton_1(MuiHelpers_createElement(Grid, [["id", "side-controls"], ["style", {
                            display: "flex",
                            flexDirection: "column",
                            position: "sticky",
                            top: 160 + "px",
                            maxWidth: 25 + "ch",
                            marginTop: 10,
                            gap: 20 + "px",
                        }], ["item", true], ["md", 4], ["lg", 3], (elements_2 = [MuiHelpers_createElement(Button, [["onClick", (_arg_11) => {
                            dispatch(new Message(2, [!model_1.AddForm]));
                        }], ["size", "small"], ["variant", "contained"], ["disabled", defaultArg(map((version_5) => version_5.Active, currentVersion), true)], ["startIcon", (props_16 = {}, react.createElement(Add, props_16))], ["children", "Legg til ny hovedmappe"]]), MuiHelpers_createElement(Button, [["onClick", (_arg_12) => {
                            handleCreateVersion();
                        }], ["variant", "contained"], ["disabled", (loading ? true : stillEditing) ? true : creating], ["startIcon", creating ? loadingIndicatorSmall() : ((props_19 = {}, react.createElement(Add, props_19)))], ["children", "Ny versjon"]]), createElement(ActivationButton, {
                            disabled: activationButtonDisabled,
                            onClose: onVersionActivated,
                            currentVersion: unwrap(currentVersion),
                        }), createElement(Versions_List_Z2855D50, {
                            loading: versionLoading,
                            currentVersion: unwrap(currentVersion),
                            versions: versions,
                            onVersionSelect: handleVersionChanged,
                        })], ["children", reactApi.Children.toArray(Array.from(elements_2))])])) : empty_1();
                    }));
                })), ["children", reactApi.Children.toArray(Array.from(elements_3))])])), delay(() => {
                    let elements_5, children_5;
                    return singleton_1(MuiHelpers_createElement(Grid, [["style", {
                        backgroundColor: "white",
                        borderRadius: 10 + "px",
                        padding: 30 + "px",
                    }], ["item", true], ["xs", 12], ["md", 11], (elements_5 = [createElement("h2", {
                        children: ["Endringslogg"],
                    }), (children_5 = singleton(createElement(Changelog_Table_727DA32F, {
                        categories: categories,
                    })), MuiHelpers_createElement(TableContainer, [["children", reactApi.Children.toArray(Array.from(children_5))]]))], ["children", reactApi.Children.toArray(Array.from(elements_5))])]));
                }));
            }));
        })), ["children", reactApi.Children.toArray(Array.from(elements_6))])])], ["children", reactApi.Children.toArray(Array.from(elems_10))])]))));
    }))))));
    return react.createElement(react.Fragment, {}, ...xs_5);
}

